<template lang="pug">
.googleChart 
  GChart.ggChart(
    :settings="{ packages: ['corechart'], language: 'fr' }",
    type="ComboChart",
    :data="chartDatas",
    :options="chartOptions",
    :resizeDebounce="10"
  )
</template>


<script>
import _ from "lodash";

import { GChart } from "vue-google-charts";

export default {
  name: "Graph",
  components: {
    GChart,
  },
  data: () => {
    return {
      chartDatas: [],
    };
  },
  props: [
    "datas",
    "graphTitle",
    "graphUnit",
    "enableLogScale",
    "enableScientificNumber",
    "maxValue",
    "seuil1",
    "seuil2",
  ],
  computed: {
    seuil1Conf() {
      return {
        value: Number(this.seuil1),
        color: "blue",
        title: "Seuil 1" + (this.graphUnit ? " (" + this.graphUnit + ")" : ""),
      };
    },
    seuil2Conf() {
      return {
        value: Number(this.seuil2),
        color: "red",
        title: "Seuil 2" + (this.graphUnit ? " (" + this.graphUnit + ")" : ""),
      };
    },
    titleAndUnit() {
      let titleAndUnit = this.graphTitle;
      if (this.graphUnit) {
        titleAndUnit = titleAndUnit + " (" + this.graphUnit + ")";
      }
      return titleAndUnit;
    },
    chartOptions() {
      return {
        title: this.titleAndUnit,
        chartArea: { left: 10, right: 10, top: 40, bottom: 30 },
        series: {
          0: {
            color: "#00b4e2",
            type: "bars",
            visibleInLegend: false,
          },
          1: {
            color: this.seuil1Conf.color,
            pointSize: 0,
            lineWidth: 1,
            areaOpacity: 0,
            lineDashStyle: [3, 3],
            type: "area",
            visibleInLegend: false,
          },
          2: {
            color: this.seuil2Conf.color,
            pointSize: 0,
            areaOpacity: 0,
            lineWidth: 1,
            lineDashStyle: [3, 3],
            type: "area",
            visibleInLegend: false,
          },
        },
        vAxis: {
          minValue: 0,
          textPosition: "in",
          scaleType: this.enableLogScale ? "log" : null,
          maxValue: this.maxValue > 0 ? this.maxValue : null,
          format: this.enableScientificNumber ? "scientific" : null,
        },
      };
    },
  },
  mounted() {
    this.computeDatas(this.datas);
  },
  methods: {
    computeDatas(val) {
      const chartDatasHeader = [
        "Date",
        this.titleAndUnit ? this.titleAndUnit : "",
      ];
      if (this.seuil1 > 0) {
        chartDatasHeader.push(this.seuil1Conf.title);
      }
      if (this.seuil2 > 0) {
        chartDatasHeader.push(this.seuil2Conf.title);
      }
      const chartDatas = [chartDatasHeader];
      const chartDatasFirst = ["", null];
      if (this.seuil1 > 0) {
        chartDatasFirst.push(this.seuil1Conf.value);
      }
      if (this.seuil2 > 0) {
        chartDatasFirst.push(this.seuil2Conf.value);
      }
      chartDatas.push(chartDatasFirst);
      _.each(val, (data) => {
        const chartDatasLocal = [data[0], data[1]];
        if (this.seuil1 > 0) {
          chartDatasLocal.push(this.seuil1Conf.value);
        }
        if (this.seuil2 > 0) {
          chartDatasLocal.push(this.seuil2Conf.value);
        }
        chartDatas.push(chartDatasLocal);
      });
      chartDatas.push(chartDatasFirst);
      this.chartDatas = chartDatas;
    },
  },
  watch: {
    datas() {
      this.computeDatas(this.datas);
    },
    seuil1() {
      this.computeDatas(this.datas);
    },
    seuil2() {
      this.computeDatas(this.datas);
    },
    maxValue() {
      this.computeDatas(this.datas);
    },
    graphTitle() {
      this.computeDatas(this.datas);
    },
    graphUnit() {
      this.computeDatas(this.datas);
    },
  },
};
</script>
<style lang="stylus" scoped>
.ggChart {
  height: 300px;
}

.googleChart {
  padding: 10px;
  background: #eee;
}
</style>

